import { ExtraOptions, Routes } from "@angular/router";

import { AdminComponent } from "./admin/admin.component";
import { AddRawConfigComponent } from "./admin/config-management/add-raw-config/add-raw-config.component";
import { ConfigManagementComponent } from "./admin/config-management/config-management.component";
import { ManageConfigComponent } from "./admin/config-management/manage-config/manage-config.component";
import { ManageTemplatesComponent } from "./admin/config-management/manage-templates/manage-templates.component";
import { TemplatedConfigComponent } from "./admin/config-management/templated-config/templated-config.component";
import { ThresholdingCrossComponent } from "./admin/config-management/thresholding-cross/thresholding-cross.component";
import { ThresholdingComponent } from "./admin/config-management/thresholding/thresholding.component";
import { ManageAllAssetsComponent } from "./admin/manage-all-assets/manage-all-assets.component";
import { AssetDataComponent } from "./admin/manage-all-assets/manage-asset/asset-data/asset-data.component";
import { AssetDestructiveComponent } from "./admin/manage-all-assets/manage-asset/asset-destructive/asset-destructive.component";
import { AssetFilesComponent } from "./admin/manage-all-assets/manage-asset/asset-files/asset-files.component";
import { FilesControlComponent } from "./admin/manage-all-assets/manage-asset/asset-files/files-control/files-control.component";
import { FilesDatafileComponent } from "./admin/manage-all-assets/manage-asset/asset-files/files-datafile/files-datafile.component";
import { FilesErrorComponent } from "./admin/manage-all-assets/manage-asset/asset-files/files-error/files-error.component";
import { AssetFirmwareComponent } from "./admin/manage-all-assets/manage-asset/asset-firmware/asset-firmware.component";
import { AssetGeneralComponent } from "./admin/manage-all-assets/manage-asset/asset-general/asset-general.component";
import { AssetNotesComponent } from "./admin/manage-all-assets/manage-asset/asset-notes/asset-notes.component";
import { AssetPartnerComponent } from "./admin/manage-all-assets/manage-asset/asset-partner/asset-partner.component";
import { ManageAssetComponent } from "./admin/manage-all-assets/manage-asset/manage-asset.component";
import { ManageFleetComponent } from "./admin/manage-all-assets/manage-fleet/manage-fleet.component";
import { ManageOrganizationComponent } from "./admin/manage-all-assets/manage-organization/manage-organization.component";
import { MasterAdminComponent } from "./admin/master-admin/master-admin.component";
import { SystemlogComponent } from "./admin/systemlog/systemlog.component";
import { UserManagementComponent } from "./admin/user-management/user-management.component";
import { AuthGuardService, AuthGuardOrgAdminService, AuthGuardGlobalAdminService, AuthGuardMasterService, AuthGuardSupportService } from "./auth-guard.service";
import { AccountComponent } from "./dashboard/account/account.component";
import { DashboardDefaultComponent } from "./dashboard/dashboard-default/dashboard-default.component";
import { DashboardComponent } from "./dashboard/dashboard.component";
import { DisableMfaComponent } from "./dashboard/disable-mfa/disable-mfa.component";
import { EnableMfaComponent } from "./dashboard/enable-mfa/enable-mfa.component";
import { AssetComponent } from "./dashboard/fleet/asset/asset.component";
import { ExceedancesComponent } from "./dashboard/fleet/asset/fdm/exceedances/exceedances.component";
import { FdmComponent } from "./dashboard/fleet/asset/fdm/fdm.component";
import { FlightMapComponent } from "./dashboard/fleet/asset/fdm/flight-map/flight-map.component";
import { MechAlertsComponent } from "./dashboard/fleet/asset/mech-diag/mech-alerts/mech-alerts.component";
import { MechCommFailuresComponent } from "./dashboard/fleet/asset/mech-diag/mech-comm-failures/mech-comm-failures.component";
import { ComponentDetailComponent } from "./dashboard/fleet/asset/mech-diag/mech-component/component-detail/component-detail.component";
import { FleetComparisonComponent } from "./dashboard/fleet/asset/mech-diag/mech-component/fleet-comparison/fleet-comparison.component";
import { MechComponentComponent } from "./dashboard/fleet/asset/mech-diag/mech-component/mech-component.component";
import { TrendCiComponent } from "./dashboard/fleet/asset/mech-diag/mech-component/trend-ci/trend-ci.component";
import { TrendHiComponent } from "./dashboard/fleet/asset/mech-diag/mech-component/trend-hi/trend-hi.component";
import { MechDiagComponent } from "./dashboard/fleet/asset/mech-diag/mech-diag.component";
import { MechEmptyComponent } from "./dashboard/fleet/asset/mech-diag/mech-empty/mech-empty.component";
import { MechEngineComponent } from "./dashboard/fleet/asset/mech-diag/mech-engine/mech-engine.component";
import { MechFirmwareComponent } from "./dashboard/fleet/asset/mech-diag/mech-firmware/mech-firmware.component";
import { MechLogComponent } from "./dashboard/fleet/asset/mech-diag/mech-log/mech-log.component";
import { MechMaintenanceComponent } from "./dashboard/fleet/asset/mech-diag/mech-maintenance/mech-maintenance.component";
import { MechUserAccessComponent } from "./dashboard/fleet/asset/mech-diag/mech-user-access/mech-user-access.component";
import { RotorTrackComponent } from "./dashboard/fleet/asset/rtb/rotor-track/rotor-track.component";
import { RotorVibeChartComponent } from "./dashboard/fleet/asset/rtb/rotor-vibe/rotor-vibe-chart/rotor-vibe-chart.component";
import { RotorVibeComponent } from "./dashboard/fleet/asset/rtb/rotor-vibe/rotor-vibe.component";
import { RtbComponent } from "./dashboard/fleet/asset/rtb/rtb.component";
import { TrackCoefficientsComponent } from "./dashboard/fleet/asset/rtb/track-coefficients/track-coefficients.component";
import { TrackHistoryComponent } from "./dashboard/fleet/asset/rtb/track-history/track-history.component";
import { VibeCheckComponent } from "./dashboard/fleet/asset/rtb/vibe-check/vibe-check.component";
import { VibeCoefficientsComponent } from "./dashboard/fleet/asset/rtb/vibe-coefficients/vibe-coefficients.component";
import { VibeHistoryComponent } from "./dashboard/fleet/asset/rtb/vibe-history/vibe-history.component";
import { FleetDefaultComponent } from "./dashboard/fleet/fleet-default/fleet-default.component";
import { FleetComponent } from "./dashboard/fleet/fleet.component";
import { UsageReportComponent } from "./dashboard/fleet/usage-report/usage-report.component";
import { ForgotComponent } from "./forgot/forgot.component";
import { LoginComponent } from "./login/login.component";
import { FleetManagementComponent } from "./orgadmin/fleet-management/fleet-management.component";
import { OrgadminComponent } from "./orgadmin/orgadmin.component";
import { OrglogComponent } from "./orgadmin/orglog/orglog.component";
import { ResetComponent } from "./reset/reset.component";
import { FleetwideAssetLoginsComponent } from "./support/fleetwide-ops/fleetwide-asset-logins/fleetwide-asset-logins.component";
import { FleetwideFirmwareComponent } from "./support/fleetwide-ops/fleetwide-firmware/fleetwide-firmware.component";
import { FleetwideOpsComponent } from "./support/fleetwide-ops/fleetwide-ops.component";
import { FleetwideSentEmailComponent } from "./support/fleetwide-ops/fleetwide-sent-email/fleetwide-sent-email.component";
import { FleetwideUserLoginsComponent } from "./support/fleetwide-ops/fleetwide-user-logins/fleetwide-user-logins.component";
import { SupportComponent } from "./support/support.component";

export const routingConfig: ExtraOptions = { paramsInheritanceStrategy: "always" };

export const appRoutes: Routes = [
	{
		path: "",
		redirectTo: "/dash",
		pathMatch: "full"
	},
	{ path: "login", component: LoginComponent },
	{ path: "forgot", component: ForgotComponent },
	{ path: "reset", component: ResetComponent },
	{
		path: "admin",
		component: AdminComponent,
		canActivate: [AuthGuardGlobalAdminService],
		children: [
			{ path: "log", component: SystemlogComponent },
			{ path: "user", component: UserManagementComponent },
			{
				path: "config",
				component: ConfigManagementComponent,
				children: [
					{ path: "", redirectTo: "manage-config", pathMatch: "full" },
					{ path: "manage-config", component: ManageConfigComponent },
					{ path: "templated-config", component: TemplatedConfigComponent },
					{ path: "add-raw-config", component: AddRawConfigComponent },
					{ path: "thresholding", component: ThresholdingComponent },
					{ path: "thresholding-cross", component: ThresholdingCrossComponent },
					{ path: "manage-templates", component: ManageTemplatesComponent, canActivate: [AuthGuardMasterService] }
				]
			},
			{
				path: "assets",
				component: ManageAllAssetsComponent,
				children: [
					{ path: "", redirectTo: "fleetwide", pathMatch: "full" },
					{
						path: "fleetwide",
						component: FleetwideOpsComponent,
						children: [
							{ path: "", redirectTo: "asset-logins", pathMatch: "full" },
							{ path: "asset-logins", component: FleetwideAssetLoginsComponent },
							{ path: "user-logins", component: FleetwideUserLoginsComponent },
							{ path: "firmware", component: FleetwideFirmwareComponent },
							{ path: "sent-emails", component: FleetwideSentEmailComponent },
						]
					},
					{ path: "org/:orgid", component: ManageOrganizationComponent },
					{ path: "org/:orgid/fleet/null", component: ManageFleetComponent },
					{ path: "org/:orgid/fleet/:fleetid", component: ManageFleetComponent },
					{
						path: "org/:orgid/fleet/:fleetid/asset/:assetid",
						component: ManageAssetComponent,
						children: [
							{ path: "", redirectTo: "asset-general", pathMatch: "full" },
							{ path: "asset-general", component: AssetGeneralComponent },
							{ path: "asset-notes", component: AssetNotesComponent },
							{
								path: "asset-files",
								component: AssetFilesComponent,
								children: [
									{ path: "", redirectTo: "control", pathMatch: "full" },
									{ path: "control", component: FilesControlComponent },
									{ path: "failed", component: FilesErrorComponent },
									{ path: "xml/:filetype", component: FilesDatafileComponent },
								]
							},
							{ path: "asset-data", component: AssetDataComponent },
							{ path: "asset-firmware", component: AssetFirmwareComponent },
							{ path: "asset-partner", component: AssetPartnerComponent },
							{ path: "asset-destructive", component: AssetDestructiveComponent }
						]
					},
				]
			},
			{
				path: "master",
				component: MasterAdminComponent,
				canActivate: [AuthGuardMasterService],
			},
		],
	},
	{
		path: "orgadmin",
		component: OrgadminComponent,
		canActivate: [AuthGuardOrgAdminService],
		children: [
			{ path: "manage", component: FleetManagementComponent },
			{ path: "log", component: OrglogComponent },
		],
	},
	{
		path: "support",
		component: SupportComponent,
		canActivate: [AuthGuardSupportService],
		children: [
			{
				path: "fleet",
				component: FleetwideOpsComponent,
				children: [
					{ path: "", redirectTo: "asset-logins", pathMatch: "full" },
					{ path: "asset-logins", component: FleetwideAssetLoginsComponent },
					{ path: "user-logins", component: FleetwideUserLoginsComponent },
					{ path: "firmware", component: FleetwideFirmwareComponent },
					{ path: "sent-emails", component: FleetwideSentEmailComponent },
				]
			},
		],
	},
	{
		path: "dash",
		component: DashboardComponent,
		canActivate: [AuthGuardService],
		children: [
			{ path: "", component: DashboardDefaultComponent },
			{ path: "account", component: AccountComponent },
			{ path: "enable-mfa", component: EnableMfaComponent },
			{ path: "disable-mfa", component: DisableMfaComponent },
			{
				path: "fleet/:fleetid",
				component: FleetComponent,
				children: [
					{ path: "", component: FleetDefaultComponent },
					{
						path: "report",
						component: UsageReportComponent,
						canActivate: [AuthGuardOrgAdminService],
					},
					{
						path: "asset/:assetid",
						component: AssetComponent,
						children: [
							{ path: "", redirectTo: "rtb", pathMatch: "full" },
							{
								path: "md",
								component: MechDiagComponent,
								children: [
									{ path: "", component: MechEmptyComponent },
									{ path: "engine", component: MechEngineComponent },
									{ path: "maintenance-log", component: MechMaintenanceComponent },
									{ path: "firmware", component: MechFirmwareComponent },
									{ path: "alerts", component: MechAlertsComponent },
									{ path: "connections", component: MechLogComponent },
									{ path: "comm-failures", component: MechCommFailuresComponent },
									{ path: "user-access", component: MechUserAccessComponent },
									{
										path: ":componentid",
										component: MechComponentComponent,
										children: [
											{ path: "", redirectTo: "hi", pathMatch: "full" },
											{ path: "hi", component: TrendHiComponent },
											{ path: "ci", component: TrendCiComponent },
											{ path: "detail", component: ComponentDetailComponent },
											{ path: "comparison", component: FleetComparisonComponent },
										]
									}
								]
							},
							{
								path: "fdm",
								component: FdmComponent,
								children: [
									{ path: "", redirectTo: "exceedances", pathMatch: "full" },
									{ path: "exceedances", component: ExceedancesComponent },
									{ path: "flight-playback", component: FlightMapComponent },
								]
							},
							{
								path: "rtb",
								component: RtbComponent,
								children: [
									{ path: "", redirectTo: "rotor-vibe", pathMatch: "full" },
									{
										path: "rotor-vibe",
										component: RotorVibeComponent,
										children: [
											{ path: ":vshaftid", component: RotorVibeChartComponent }
										]
									},
									{ path: "rotor-track", component: RotorTrackComponent },
									{ path: "vibe-check", component: VibeCheckComponent },
									{ path: "vibe-history", component: VibeHistoryComponent },
									{ path: "track-history", component: TrackHistoryComponent },
									{
										path: "vibe-coefficients",
										component: VibeCoefficientsComponent,
										children: [
											{ path: ":vshaftid", component: RotorVibeChartComponent }
										]
									},
									{ path: "track-coefficients", component: TrackCoefficientsComponent },
								]
							},
						],
					},
				]
			},
		]
	},
	{ path: "**", redirectTo: "/dash" }
];
